import React, { Component } from 'react';
import { emitter } from "../../utils/emitter";
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import * as valid from '../../utils/validate'


import * as messageService from "../../services/messageService"



class UserModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: 0,
            code: '',
            userName: '',
            name: '',
            lastName: '',
            email: '',
            address: '',
            companyName: '',
            phoneNumber: '',
            avatar: '',
            password: '',
            isSA: false,
            isShowPass: true
        }
        this.listenEmitter();
    }
    componentDidMount() {

    }
    listenEmitter = () => {
        emitter.on("CLEAR_DATA_MODAL", () => {
            this.setState({
                id: 0,
                code: '',
                userName: '',
                name: '',
                lastName: '',
                email: '',
                address: '',
                companyName: '',
                phoneNumber: '',
                avatar: '',
                isShowPass: true,
                isSA: false
            })
        })
        emitter.on("DATA_MODAL", (data) => {
            this.setState({
                id: data.id,
                code: data.code,
                userName: data.userName,
                name: data.name,
                lastName: data.lastName,
                email: data.email,
                address: data.address,
                companyName: data.companyName,
                phoneNumber: data.phoneNumber,
                avatar: data.avatar,
                isShowPass: false,
                isSA: data.isSA
            })
        })
    }
    handleChangeChk = (event, id) => {
        let copyState = { ...this.state };
        copyState[id] = event.target.checked;
        this.setState({
            ...copyState
        })
    }
    onChangeInput = (event, id) => {
        let copyState = { ...this.state };
        copyState[id] = event.target.value;
        this.setState({
            ...copyState
        })
    }
    toggle = () => {
        this.props.toggleFromParent();
    }
    onSubmit = async () => {
        if (!this.isValidData()) return;
        this.setState({
            code: this.state.email
        },
            () => {
                this.props.save(this.state);
            })

    }
    isValidData = () => {
        let arr = ["email", "name", "phoneNumber"]
        let arrS = ["email", "họ & tên", "số điện thoại"]
        for (let i = 0; i < arr.length; i++) {
            if (!this.state[arr[i]]) {
                messageService.messageNotify('', ('Vui lòng nhập ' + arrS[i]), 'warning');
                return false;
            }
            else if (this.state.isShowPass && !this.state.password) {
                messageService.messageNotify('', 'Vui lòng nhập mật khẩu', 'warning');
            }
        }
        if (!valid.validateEmail(this.state.email)) {
            messageService.messageNotify('', 'Email không đúng định dạng', 'warning');
            return false;
        }
        return true;
    }
    render() {
        let isShow = this.state.isShowPass
        return (
            <>
                <Modal
                    isOpen={this.props.isOpenModal}
                    toggle={() => { this.toggle() }}
                    className={"modal-lg"}
                >
                    <ModalHeader toggle={() => { this.toggle() }}>{this.props.titleModal}</ModalHeader>
                    <ModalBody>
                        <div className="row">
                            <div className="mb-1 col-md-6">
                                <label className="form-label">Email</label>
                                <input type="text" className="form-control" placeholder="Email"
                                    onChange={(event) => this.onChangeInput(event, "email")}
                                    value={this.state.email} />
                            </div>
                            {
                                isShow && <div className="mb-1 col-md-6" >
                                    <label className="form-label">Mật khẩu</label>
                                    <input
                                        value={this.state.password} id='password' name='password'
                                        type={'password'}
                                        onChange={(event) => this.onChangeInput(event, "password")}
                                        className="form-control pe-5 password-input" placeholder="nhập mật khẩu" />
                                </div>
                            }
                            <div className="mb-1 col-md-6">
                                <label className="form-label">Họ & tên</label>
                                <input type="text" className="form-control" placeholder="nhập họ & tên"
                                    onChange={(event) => this.onChangeInput(event, "name")}
                                    value={this.state.name} />
                            </div>
                            <div className="mb-1 col-md-6">
                                <label className="form-label">Số điện thoại</label>
                                <input type="text" className="form-control" placeholder="nhâp số điện thoại"
                                    onChange={(event) => this.onChangeInput(event, "phoneNumber")}
                                    value={this.state.phoneNumber} />
                            </div>
                            <div className="mb-1 col-md-6">
                                <label className="form-label">Supper admin</label>
                                <input
                                    style={{ width: '10%' }} type="checkbox"
                                    defaultChecked={this.state.isSA}
                                    onChange={(event) => this.handleChangeChk(event, 'isSA')} />
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button className='btn-xs' onClick={() => this.onSubmit()} color="primary" >
                            <i className="fas fa-save"></i> Lưu
                        </Button>{' '}
                        <Button className='btn-xs' onClick={() => this.toggle()} color="danger" >
                            <i className="fas fa-close"></i>  Hủy
                        </Button>
                    </ModalFooter>
                </Modal>
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(UserModal);
